import React from 'react';
import { useReveal } from '../../hooks/useReveal';
import { OPS_PILLARS, OPS_PILLARS_INTRO } from '../../data/about';
import '../../styles/OpsPillars.css';

const OpsPillars: React.FC = () => {
  const { ref, revealed } = useReveal<HTMLElement>();

  return (
    <section
      ref={ref}
      className={`ops psl-reveal${revealed ? ' is-in-view' : ''}`}
    >
      <div className="ops__header">
        <div className="ops__chapter">{OPS_PILLARS_INTRO.chapter}</div>
        <p className="ops__label">{OPS_PILLARS_INTRO.label}</p>
      </div>

      <div className="ops__grid">
        {OPS_PILLARS.map((p) => (
          <article className="ops__pillar" key={p.num}>
            <div className="ops__num" aria-hidden="true">
              {p.num}
            </div>
            <h3 className="ops__title">{p.title}</h3>
            <p className="ops__body">{p.body}</p>
            {p.note && <span className="ops__note">{p.note}</span>}
          </article>
        ))}
      </div>
    </section>
  );
};

export default OpsPillars;
